import moment from 'moment-timezone';

import React, { useEffect, useState } from 'react';

import { TooltipHost } from 'office-ui-fabric-react';
import { BiInfoCircle } from "react-icons/bi";




const WsTimestamp = (props: { timestamp: Date }) => {

  const [ timer, setTimer ] = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {
      setTimer(prev => prev + 1);
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const momentDate = moment(props.timestamp);
  const textDate = momentDate.format('HH:mm:ss, DD/MM/YYYY');
  const isoDate = momentDate.toISOString();

  return (
    <>
      {momentDate.fromNow()}
      <TooltipHost
        // directionalHint={DirectionalHint.bottomCenter}
        content={textDate}
        id={`ws-timestamp-tooltip-${isoDate}`}
        className="ws-timestamp-tooltip"
        calloutProps={{
          className: 'ws-timestamp-tooltip-callout',
          style: {
            // width: '200px'
          }
        }}
      >
        <BiInfoCircle
          aria-describedby={`ws-timestamp-tooltip-${isoDate}`}
          style={{
            fontSize: '16px',
            verticalAlign: 'middle',
            marginLeft: '5px',
            marginTop: '-3px'
          }}
        />
      </TooltipHost>
    </>
  );
};




export {
  WsTimestamp
};
